import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import Layout from "../../components/Layout";
import { FileText, Hammer, CaretRight } from "@phosphor-icons/react";

const OPEN_QUOTE = ["draft", "sent", "viewed"];
const OPEN_JOB = ["draft", "sent", "viewed"];

export default function QuotesHome() {
  const [counts, setCounts] = useState({ quotes: null, jobs: null });
  useEffect(() => {
    api.get("/quotes").then((r) => setCounts((c) => ({ ...c, quotes: r.data.filter((q) => OPEN_QUOTE.includes(q.status)).length }))).catch(() => {});
    api.get("/jobs").then((r) => setCounts((c) => ({ ...c, jobs: r.data.filter((j) => OPEN_JOB.includes(j.status)).length }))).catch(() => {});
  }, []);
  return (
    <Layout title="Quotes">
      <div className="space-y-3" data-testid="quotes-chooser">
        <Link to="/quotes/service" data-testid="quotes-service-row">
          <div className="card-flat flex items-center gap-4 p-6 transition-colors hover:bg-muted/50">
            <FileText size={32} weight="bold" className="text-primary" />
            <div className="flex-1">
              <p className="text-lg font-bold">Service quotes</p>
              <p className="text-sm text-muted-foreground">Seasonal &amp; one-time quotes for recurring work{counts.quotes !== null ? ` · ${counts.quotes} open` : ""}</p>
            </div>
            <CaretRight size={20} weight="bold" className="text-muted-foreground" />
          </div>
        </Link>
        <Link to="/jobs" data-testid="quotes-projects-row">
          <div className="card-flat flex items-center gap-4 p-6 transition-colors hover:bg-muted/50">
            <Hammer size={32} weight="bold" className="text-primary" />
            <div className="flex-1">
              <p className="text-lg font-bold">Project jobs</p>
              <p className="text-sm text-muted-foreground">Multi-line project quotes, deposits &amp; jobs{counts.jobs !== null ? ` · ${counts.jobs} open` : ""}</p>
            </div>
            <CaretRight size={20} weight="bold" className="text-muted-foreground" />
          </div>
        </Link>
      </div>
    </Layout>
  );
}
